import React from "react";
import "./DrawerOverlay.scss";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CloseIcon from "@material-ui/icons/Close";

class SettingTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profitMargin: '',
      targetMargin: '',
      definedhourlyRate: '',
      billableSwitch: false,
      changed: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlerTargetMargin = this.handlerTargetMargin.bind(this);
    this.handlerProfitMargin = this.handlerProfitMargin.bind(this);
    this.handlerHourlyRate = this.handlerHourlyRate.bind(this);
  }
  componentDidMount() {
    const props = this.props;

    const billableSwitch =
      props.estimates?.billableSwitch ||
      props.company?.billableSwitch ||
      true;
    this.setState({
      profitMargin: props.estimates?.profitMargin,// '',props.currentProfit || '',
      targetMargin: props.estimates?.targetMargin || '',
      //   parseFloat(props.company?.targetMargin) ||
      //   0,
      definedhourlyRate:
        parseFloat(props.estimates?.definedhourlyRate) ||
        // parseFloat(props.company?.hourlyRate) ||
        '',
      billableSwitch,
      changed: false,
    });

  }

  handlerTargetMargin(e) {
    const number = /^[0-9\b]+$/;
    if (e.target.value === "" || number.test(e.target.value)) {
      this.setState({
        targetMargin: e.target.value.slice(0, 10),
        changed: true,
      });
      e.target.value
        ? e.currentTarget.classList.add("field-value")
        : e.currentTarget.classList.remove("field-value");
    }
  }

  handlerProfitMargin(e) {
    const number = /^[0-9\b]+$/;
    if (e.target.value === "" || number.test(e.target.value)) {
      this.setState({
        profitMargin: e.target.value.slice(0, 10),
        changed: true,
      });
      e.target.value
        ? e.currentTarget.classList.add("field-value")
        : e.currentTarget.classList.remove("field-value");
    }
  }

  handlerHourlyRate(e) {
    const number = /^[0-9\b]+$/;
    if (e.target.value === "" || number.test(e.target.value)) {
      this.setState({
        definedhourlyRate: e.target.value.slice(0, 10),
        changed: true,
      });
      e.target.value
        ? e.currentTarget.classList.add("field-value")
        : e.currentTarget.classList.remove("field-value");
    }
  }

  handleSubmit(e) {
    const haveValue = (d) => {
      return d !== null && d !== undefined;
    };
    const { targetMargin, profitMargin, definedhourlyRate, billableSwitch = false } = this.state;

    const { estimates, company } = this.props;
    const data = { billableSwitch };
    const setValue = (val, key) => {
      if (val !== company[key] || haveValue(estimates[key])) {
        data[key] = val;
      }
    };
    setValue(targetMargin, "targetMargin");
    setValue(profitMargin, "profitMargin");
    setValue(definedhourlyRate, "definedhourlyRate");

    e.preventDefault();
    this.props.updateEstimate(data);
    this.props.onClose(e);
  }
  render() {
    const {
      billableSwitch = true,
      targetMargin = '',
      profitMargin = '',
      definedhourlyRate,
      changed = true,
    } = this.state;
    const disabledInputs = billableSwitch === false;

    return (
      <div id="setting" className="side-item">
        <div className="title">
          <h5>
            Estimate Setting
            <div className="cross" onClick={this.props.onClose}>
              <CloseIcon htmlColor="#084d4f" />
            </div>
          </h5>
        </div>
        <FormGroup className="bill_switch">
          <FormControlLabel
            control={<Switch />}
            label="Billable"
            checked={billableSwitch}
            onChange={() =>
              this.setState({ billableSwitch: !billableSwitch, changed: true })
            }
          />
        </FormGroup>
        <div className="input-wrap">
          <h6>TARGET PROJECT MARGIN</h6>
          <p>Used to calculate price, cost, and billable rate</p>
          <div className="d_input">
            <TextField
              variant="outlined"
              name="target"
              type="text"
              label="Target Margin"
              onChange={this.handlerTargetMargin}
              value={billableSwitch ? targetMargin : "N/A"}
              disabled={disabledInputs}
              InputProps={{
                endAdornment: <span className="side_percentage">%</span>,
              }}
            />
          </div>

          <h6>VENDOR UPSELL</h6>
          <p>Set the percent profit margin for your contracted vendors</p>
          <div className="d_input">
            <TextField
              variant="outlined"
              type="text"
              label="Profit Margin"
              onChange={this.handlerProfitMargin}
              value={!billableSwitch ? "N/A" : profitMargin}
              disabled={disabledInputs}
              InputProps={{
                endAdornment: <span className="side_percentage">%</span>,
              }}
            />
          </div>
          <h6>PROJECT HOURLY RATE</h6>
          <p>
            Setting this rate will override any calculations made based off of
            costs dictated for resources in settings
          </p>
          <div className="d_input discitem">
            <TextField
              variant="outlined"
              onChange={this.handlerHourlyRate}
              InputProps={{
                endAdornment: <span className="side_dollar">$</span>,
              }}
              type="text"
              label="Enter rate"
              value={!billableSwitch ? "N/A" : definedhourlyRate}
              disabled={disabledInputs}
            />
          </div>
          <Button
            variant="contained"
            type="button"
            className="duplicate apply"
            disabled={!changed}
            onClick={this.handleSubmit}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }
}

export default SettingTemplate;
